import React from 'react';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import {
  SuccessContainer,
  IllustrationWrapper,
  Illustration,
  StoreBadgeContainer,
  StoreBadgeLink,
  QRCodeWrapper,
  QRCode,
} from './ReadyToStart.styles';

import AppStoreBadge from '@/assets/AppStore.svg';
import GooglePlayBadge from '@/assets/GooglePlay.svg';
import DaylightIllustration from '@/assets/Party_Confetti.svg';
import {
  DAYLIGHT_APP_STORE_URL,
  DAYLIGHT_GOOGLE_PLAY_URL,
  DAYLIGHT_SMART_LINK_URL,
} from '@/pages/Onboarding/utils/constants';
import { getPlatform } from '@/pages/Onboarding/utils/platformHelpers';
import { Platform } from '@/utils/productHelpers';

const ReadyToStart: React.FC = () => {
  const { t } = useTranslation();
  const platform = getPlatform();

  let storeContent;

  if (platform === Platform.iOS) {
    storeContent = (
      <StoreBadgeContainer>
        <StoreBadgeLink
          href={DAYLIGHT_APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="app-store-link"
        >
          <img src={AppStoreBadge} alt="Download on the App Store" />
        </StoreBadgeLink>
      </StoreBadgeContainer>
    );
  } else if (platform === Platform.Android) {
    storeContent = (
      <StoreBadgeContainer>
        <StoreBadgeLink
          href={DAYLIGHT_GOOGLE_PLAY_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="google-play-link"
        >
          <img src={GooglePlayBadge} alt="Get it on Google Play" />
        </StoreBadgeLink>
      </StoreBadgeContainer>
    );
  } else {
    storeContent = (
      <QRCodeWrapper>
        <QRCode
          data-testid="qr-code"
          value={DAYLIGHT_SMART_LINK_URL}
        />
      </QRCodeWrapper>
    );
  }

  return (
    <SuccessContainer>
      <IllustrationWrapper>
        <Illustration src={DaylightIllustration} alt="Success" />
      </IllustrationWrapper>
      <Typography variant="h2" style={{ marginBottom: 8 }}>
        {t('coverage.spring_health.ready_to_start.title')}
      </Typography>
      <Typography style={{ marginBottom: 16 }}>
        {t('coverage.spring_health.ready_to_start.subtitle')}
      </Typography>
      {storeContent}
    </SuccessContainer>
  );
};

export default ReadyToStart;
